<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" md="3" xs="12" sm="12">
        <v-text-field
          autocomplete="off"
          type="text"
          dense
          outlined
          label="Account Name"
          v-model="record.Name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3" xs="12" sm="12">
        <v-autocomplete
          automplete="off"
          dense
          outlined
          v-model="record.Category"
          :items="categories"
          label="Account Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-text-field
          autocomplete="off"
          type="text"
          dense
          outlined
          label="Opening Balance"
          v-model="record.Balance"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="12" xs="12" sm="12">
        <v-btn
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "AccountsIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    createDoc: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    accountTypes: [
      { name: "Cash", value: "C" },
      { name: "Mpesa", value: "M" },
      { name: "Bank", value: "B" },
      { name: "Float", value: "F" },
    ],
    categories: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (this.record.Balance == null || this.record.Balance == undefined) {
        this.$refs.snackbar.show("Please enter Opening Balance or 0", "red");
      } else {
        this.$store.commit("btnLoader", true);
        this.record.BankingAcc = "N";
        this.$emit("data", this.record);
      }
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/expenses-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCategories();
  },
};
</script>